import { IState, DispatchedTulip } from './state';
import { useEffect, useState } from 'react';

export function useApplicationState<T>(state: IState<T>): DispatchedTulip<T> {
	const [, forceUpdate] = useState([]);

	useEffect(() => {
		return state.subscribe(() => {
			forceUpdate([]);
		});
	}, []);

	return state.read();
}
